module.exports = __webpack_public_path__ + "static/media/favoriteStarOff.34987567.svg";